module.exports = __webpack_public_path__ + "img/39-Truffle Oak VLF.jpg";